module.exports = __webpack_public_path__ + "img/Group.100470ca.png";